export enum MessageReactionType {
    LIKE = 'LIKE',
    HIGH_FIVE = 'HIGH_FIVE',
    LAUGH = 'LAUGH',
    WOW = 'WOW'
}
